import { StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import { UvFilter } from '../../../context/FreshWater/types'
import { handleColorState } from '../../../helpers/handleColorsState'
import { corporateColor, disabledGray, white } from '../../../theme/colors'
import { Separator } from '../../../components/Separator'
import { Option } from '../../../context/SeaWater/types'
import { useEffect, useState } from 'react'
import { InfoState } from '..'
// import { useTranslation } from 'react-i18next'

interface OptionsProps {
  item: UvFilter
  isLastItem: boolean
  options: Option[]
  onChange: (value: InfoState) => void
  defaultOptions?: Option
}

export const ListItem = ({ item, isLastItem, options, onChange, defaultOptions }: OptionsProps) => {
  // const { t } = useTranslation()

  const [selected, setSelected] = useState<{
    [key: string]: boolean
  }>({})

  const handleSelected = (id: number) => {
    setSelected((prev) => {
      return {
        [id]: !prev[id],
      }
    })
  }
  useEffect(() => {
    if (defaultOptions) {
      onChange({
        levelThreeId: item.filterId,
        stateId: defaultOptions.id,
        levelThreeName: item.name,
        currentState: item.currentState,
        newState: options.find((item) => item.id === defaultOptions.id)?.name ?? '',
      })

      handleSelected(defaultOptions.id)
    }
  }, [])

  useEffect(() => {
    handleSelected(item.currentStateId)
  }, [item])

  return (
    <>
      <View style={[styles.container, isLastItem && { marginBottom: 100 }]}>
        <View style={{ flex: 0.8 }}>
          <Text style={styles.stateText}>{item.name}</Text>
        </View>

        <View style={{ flex: 1 }}>
          <View style={styles.containerRadioButton}>
            {options.map((option) => (
              <TouchableOpacity
                style={styles.radioButtonContainer}
                onPress={() => {
                  onChange({
                    levelThreeId: item.filterId,
                    stateId: option.id,
                    levelThreeName: item.name,
                    currentState: item.currentState,
                    newState: options.find((item) => item.id === option.id)?.name ?? '',
                  })
                  handleSelected(option.id)
                }}
                key={option.id}
              >
                <View
                  style={[
                    styles.radioButton,
                    selected[option.id] && { backgroundColor: handleColorState(option.name) },
                  ]}
                >
                  <Text style={styles.radioButtonLabel}>{option.name}</Text>
                </View>
              </TouchableOpacity>
            ))}
          </View>
        </View>
      </View>
      {!isLastItem && <Separator />}
    </>
  )
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 5,
  },
  stateText: {
    color: corporateColor,
    fontWeight: 'bold',
  },
  currentStateColumn: {
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1.3,
  },
  currentStateContainer: {
    padding: 10,
    width: 80,
    borderRadius: 5,
    alignItems: 'center',
    margin: 10,
  },
  currentStateText: {
    color: white,
    fontWeight: 'bold',
  },

  containerRadioButton: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    gap: 8,
    alignItems: 'center',
    flex: 1,
  },
  radioButton: {
    height: 28,
    width: 50,
    borderRadius: 5,
    borderColor: corporateColor,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 4,
    backgroundColor: disabledGray,
  },
  radioButtonContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  radioButtonInner: {
    height: 8,
    width: 8,
    borderRadius: 6,
    backgroundColor: 'white',
  },
  radioButtonLabel: {
    fontSize: 12,
    color: white,
    fontWeight: 'bold',
  },
})
